/*
 * @Author: Terry
 * @Date: 2022-03-15 11:14:51
 * @LastEditors: Terry
 * @LastEditTime: 2022-04-12 11:06:07
 * @FilePath: /toutiao_01/src/api/home.js
 * @Description: 文章相关
 * Copyright (c) 2022 by ccde_terry@163.com, All Rights Reserved. 
 */

import {get,post} from '../utils/request'
/**
 * 获取文章列表
 * @param {} params 
 * @returns 
 */
// 返回promise对象
// return request.get('api/article/getlist', qs.stringify(params))
export const getArticleList = param => get('api/article/getlist', param)
export const getBannerApi = param => get('api/banner/getlists', param)



// 对文章不敢兴趣
export function disLikeById (target) {
  return request.post('article/dislikes',{target})
}

export function reportById (target, type) {
  return request.post('article/reports', {
    target, type
  })
}
